import { RouteView } from '@/components/layouts'

export default {
	path: '/partner',
	component: RouteView,
	name: 'partner',
	redirect: '/partner/partnerList',
	meta: {
		title: '资源公司管理',
		icon: {
			type: 'handshake',
		},
		permission: [
			'partnerCompanies',
			'partnerOrderList',
			'visitorList',
			'checkList',
		],
	},
	children: [
		{
			path: '/partner/partnerList',
			name: 'partnerList',
			component: () => import('@/views/partner/partnerList/partnerList.vue'),
			meta: {
				title: '资源公司详情',
				permission: ['partnerCompanies'],
			},
		},
		{
			path: '/partner/order/orderList',
			name: 'partnerOrderList',
			component: () => import('@/views/partner/order/orderList.vue'),
			meta: {
				title: '订单作业列表',
				permission: ['partnerOrderList'],
			},
		},
		{
			path: '/partner/orderDetail/:canChecked/:orderId/:dispatchId',
			name: 'partnerOrderDetail',
			component: () => import('@/views/partner/order/orderDetail.vue'),
			hidden: true,
			meta: {
				title: '订单作业详情',
			},
		},
		{
			path: '/partner/workDetail/:orderId/:dispatchId',
			name: 'partnerWorkDetail',
			component: () => import('@/views/partner/order/workDetail.vue'),
			hidden: true,
			meta: {
				title: '作业详情',
			},
		},
		{
			path: '/partner/visitor/visitorList',
			name: 'partnerVisitorList',
			component: () =>
				import(
					/* webpackChunkName: "Visitor" */ '@/views/partner/visitor/visitorList.vue'
				),
			meta: {
				title: '作业人员列表',
				permission: ['visitorList'],
			},
		},
		{
			path: '/partner/visitorDetail/:mobile/:id',
			name: 'partnerVisitorDetail',
			component: () =>
				import(
					/* webpackChunkName: "VisitorDetail" */ '@/views/partner/visitor/visitorDetail.vue'
				),
			hidden: true,
			meta: {
				title: '作业人员明细',
			},
		},
		{
			path: '/partner/firstAudit/firstAuditList',
			name: 'partnerFirstAuditList',
			component: () =>
				import(
					/* webpackChunkName: "Partner" */ '@/views/partner/firstAudit/firstAuditList.vue'
				),
			meta: {
				title: '初审管理列表',
				permission: ['checkList'],
			},
		},
		{
			path: '/partner/firstAudit/firstAuditDetail/:id',
			name: 'partnerFirstAuditDetail',
			component: () =>
				import('@/views/partner/firstAudit/firstAuditDetail.vue'),
			hidden: true,
			meta: {
				title: '初审管理详情',
				permission: ['firstAuditDetail'],
			},
		},
		{
			path: '/partner/addAuditInfo',
			name: 'partnerAddAuditInfo',
			component: () => import('@/views/partner/firstAudit/addAuditInfo.vue'),
			hidden: true,
			meta: {
				title: '新建审核信息',
			},
		},
		{
			path: '/partner/updateAuditInfo',
			name: 'partnerUpdateAuditInfo',
			component: () => import('@/views/partner/firstAudit/updateAuditInfo.vue'),
			hidden: true,
			meta: {
				title: '修改审核信息',
			},
		},
		{
			path: '/partner/partnerDetail/:partnerId',
			name: 'partnerDetail',
			component: () => import('@/views/partner/partnerList/partnerDetail.vue'),
			hidden: true,
			meta: {
				title: '资源公司明细',
				permission: ['partnerDetail'],
			},
		},
	],
}
